import createUseContext from "constate";
import { runSystem, extractSources } from "./system";

var Container = function Container(options) {
  var sources = runSystem(options);
  var pureSources = extractSources(sources);
  return {
    sources: sources,
    pureSources: pureSources
  };
};

var _a = createUseContext(Container),
    Provider = _a.Provider,
    Context = _a.Context;

var DC = {
  Provider: Provider,
  Context: Context
};
export { DC, Provider as DCProvider, Context as DCContext };